// alertService.ts
export type AlertType = "success" | "error" | "warning";

type AlertData = { type: AlertType; message: string };

let showAlertHandler: ((data: AlertData) => void) | null = null;

export const setShowAlertHandler = (handler: (data: AlertData) => void) => {
  showAlertHandler = handler;
};

export const AlertModalTrigger = (type: AlertType, message: string) => {
  if (showAlertHandler) {
    showAlertHandler({ type, message });
  } else {
    console.warn("Alert handler not registered");
  }
};
